import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useOutletContext } from 'react-router-dom';
import Layout from '../components/Layout';
import CourseDetail from '../student_pages/CourseDetail';

// PageWrapper component to handle page titles
const PageWrapper = ({ children, title }) => {
  const { setPageTitle } = useOutletContext() || {};
  useEffect(() => {
    if (setPageTitle && title) {
      setPageTitle(title);
    }
  }, [title, setPageTitle]);
  return <>{children}</>;
};

// Placeholder for pages that are not yet built
const PlaceholderPage = ({ title }) => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2>{title} - Coming Soon 🚧</h2>
    <p>This feature will be available soon.</p>
  </div>
);

export default function StudentRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Default redirect for /student to the course detail page */}
        <Route index element={<Navigate to="ug/course-detail/1" replace />} />
        
        {/* Academic Routes from sidebarConfig */}
        <Route path="my-courses" element={<PageWrapper title="My Courses"><PlaceholderPage title="My Courses" /></PageWrapper>} />
        <Route path="my-grades" element={<PageWrapper title="My Grades"><PlaceholderPage title="My Grades" /></PageWrapper>} />
        <Route path="attendance" element={<PageWrapper title="My Attendance"><PlaceholderPage title="My Attendance" /></PageWrapper>} />

        {/* Route for the new Student UG module */}
        <Route path="ug/course-detail/:courseId" element={<PageWrapper title="Course Details"><CourseDetail /></PageWrapper>} />

        {/* Finance Routes from sidebarConfig */}
        <Route path="fee-payment" element={<PageWrapper title="Fee Payment"><PlaceholderPage title="Fee Payment" /></PageWrapper>} />
        <Route path="payment-history" element={<PageWrapper title="Payment History"><PlaceholderPage title="Payment History" /></PageWrapper>} />
      </Route>
    </Routes>
  );
}